import { get } from 'lodash';
import { toApiImageFormat, toAppImageFormat } from './imageDataMapper';

export const mapHeaderToApiModel = ({
  clientUuid,
  backgroundImage,
  backgroundImageSize,
  logoImage,
  logoImageAlign,
  logoWithTextAlign,
  height,
  backgroundColor,
  isFullWidth,
  backgroundCoords,
  contentEnabled,
  layout,
  textContent,
  sectionAssignee,
}) => ({
  client_uuid: clientUuid,
  background_image: toApiImageFormat(backgroundImage),
  logo_image: toApiImageFormat(logoImage),
  content: {
    logo_image_align: logoImageAlign,
    logo_with_text_align: logoWithTextAlign,
    height,
    background_color: backgroundColor,
    is_full_width: isFullWidth,
    background_image_size: backgroundImageSize,
    background_coordinates: backgroundCoords,
    logo_enabled: contentEnabled,
    layout,
    text_content: textContent,
  },
  section_assignee: sectionAssignee,
  type: 'header',
});

export const toHeaderBlockFormat = ({
  id,
  client_uuid: clientUuid,
  type_: type,
  background_image: backgroundImage,
  logo_image: logoImage,
  content,
  section_assignee,
}) => ({
  id,
  clientUuid,
  type,
  backgroundImage: toAppImageFormat(backgroundImage),
  logoImage: toAppImageFormat(logoImage),
  logoImageAlign: get(content, 'logo_image_align'),
  logoWithTextAlign: get(content, 'logo_with_text_align'),
  height: get(content, 'height'),
  backgroundColor: get(content, 'background_color'),
  isFullWidth: get(content, 'is_full_width') || false,
  backgroundImageSize: get(content, 'background_image_size'),
  backgroundCoords: get(content, 'background_coordinates'),
  contentEnabled: get(content, 'logo_enabled'),
  layout: get(content, 'layout'),
  sectionAssignee: section_assignee,
  textContent: get(content, 'text_content'),
});

export const mapHeaderFromApiModel = ({ data: [{ id, attributes }] }) =>
  toHeaderBlockFormat({ id, ...attributes });
